<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <IndexView/>
  <section class="p-6">
    <BackButton class="mb-5" to_url="/stock-opname" />
    <PageTitle title="Tambah Stok Opname"/>
    <div class="w-3/4 md:w-3/4 lg:w-1/2 bg-white p-6 rounded-md shadow-md">
      <InputRadio
        v-model="formType" id="form-type" name="form-type" label="Tipe Stok Opname"
        :options="[{ value: 'common', label: 'Stock Opname' }, { value: 'misc', label: 'Lain-lain' }]"
        :valid="validation.form_type.valid"
        :error-message="validation.form_type.message"
      />
      *field lain*

      <div class="flex justify-center">
        <SubmitButton id="submit" @click="submitStockOpname" button_name="Buat Draft" button_class="mt-3 rounded-md bg-color-1 px-6 py-2 text-base font-semibold text-color-4 shadow-sm hover:bg-color-2 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-color-3 block"/>
      </div>
    </div>
  </section>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputRadio from '@/components/form/InputRadio.vue';
// import TextArea from '@/components/form/TextArea.vue';
import SubmitButton from '@/components/form/SubmitButton.vue';
import { mapActions } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton, InputRadio, SubmitButton, Button, ConfirmDialog, Toast
  },
  data() {
    return {
      formType: null,
      isEdit: false,
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
      },
    }
  },
  methods: {
    ...mapActions('stock_opnames', ['createStockOpname']),
    submitStockOpname() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin membuat draft stok opname?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postStockOpname();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan draft stok opname', life: 3000 });
        }
      });
    },
    async postStockOpname() {
      try {
        const stockOpnameData = {
          form_type: this.formType,
        };

        const { data } = await this.createStockOpname(stockOpnameData);

        // if (this.isEdit && this.stockOpname) {
        //   stockOpnameData.id = this.stockOpname.id;
        //   await this.updateStockOpname(stockOpnameData);
        // }
        // else {
        //   await this.createStockOpname(stockOpnameData);
        // }

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Stock Opname telah dibuat', life: 5000 });
        this.$router.push(`/stock-opname/edit/${data.id}`);
      }
      catch (error) {
        console.error('Failed to save stock opname:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  },
  async created() {
    
  }
}
</script>